import { DateTime } from 'luxon'

export function normalizeDateInput(value: string): string {
  const trimmed = value.trim()
  if (!trimmed) return trimmed

  const iso = DateTime.fromISO(trimmed, { setZone: true })
  if (iso.isValid) return iso.toUTC().toISO()!

  if (/^-?\d+$/.test(trimmed)) {
    const millis = DateTime.fromMillis(Number(trimmed))
    if (millis.isValid) return millis.toUTC().toISO()!
  }

  throw new Error(`Invalid date: ${trimmed}`)
}
